import {lory} from 'lory.js';
import CONF from '../utils/conf';
import du from '../utils/dom-utilities';

/**
 * responsiveSwipeItem - Activate a swipe slider on a itemlist inside a defined breakpoint
 * -- DOM exemple: <div data-responsive-swipe-item="md">...<Frame and container, see lory.js doc>...</div>
 * @export
 * @function
 * @param {String} targetDataAttribute Data-attribute name, should have a mq value on dom (see conf.js).
 * @return {Object[]} Array of lory.js slider object
 */
const initResponsiveSwipeItem = (targetDataAttribute = 'data-responsive-swipe-item') => {

    return du.queryAll(`[${targetDataAttribute}]`).map((DOMTarget) => {
        const options = {
            enableMouseEvents: true,
            classNameFrame: 'js-responsiveSwipeItem-frame', // 'js-annual-report-list__frame',
            classNameSlideContainer: 'js-responsiveSwipeItem-container' ,//'js-annual-report-list__items',
            slidesToScroll: 1
        };
        const breakpointValue = DOMTarget.getAttribute(targetDataAttribute);

        const slider = lory(DOMTarget, options);

        window.innerWidth < CONF.mq[breakpointValue] ? slider.setup() : slider.destroy(); //769

        du.onEvent(window, 'optimized-resize', () => {
            window.innerWidth < CONF.mq[breakpointValue] ? slider.setup() : slider.destroy();
        });

        return slider;
    });
};

export default initResponsiveSwipeItem;



// WEBPACK FOOTER //
// ./src/main/js/components/responsiveSwipeItem.js